import { Link } from 'react-router-dom'
// import { ReactComponent as LogoSvg } from './logo.svg'

import styles from './Logo.module.scss'

interface LogoProps {
  target?: string
  hideText?: boolean
  className?: string
  disableResponsive?: boolean
}

const Logo = ({
  target,
  hideText,
  className,
  disableResponsive,
}: LogoProps) => {
  return (
    <>
      <Link to="/" className={styles.logo} target={target} title="DSocial">
        <img
          src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687142470050_LOGODSOCIAL 1.svg"
          alt=""
        />
      </Link>
      <Link
        to="/"
        className={styles.logo_phone}
        target={target}
        title="DSocial"
      >
        <img
          src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1688119339792_LOGODSOCIAL 1.png"
          alt=""
        />
      </Link>
    </>
    // <h1 className={`${styles.logoWrapper} ${className}`}>
    //   <Link to="/" className={styles.logo} target={target} title="DSocial">
    //     {/* <LogoSvg /> */}
    //     <img
    //       src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687142470050_LOGODSOCIAL 1.svg"
    //       alt=""
    //     />
    //     {!hideText && (
    //       <span className={disableResponsive ? '' : styles.text}>DSocial</span>
    //     )}
    //   </Link>
    // </h1>
  )
}

export default Logo
